import { useContext } from 'react';

import { Ctx, TContextDispatch } from '~/src/components/ConnectDomruPopup/context';

export const useContextDispatch = (): TContextDispatch => {
    const { dispatch } = useContext(Ctx);
    return dispatch;
};
